// extracted by mini-css-extract-plugin
export default {"link":"Modal_link__yjpE2","wrapper":"Modal_wrapper__ru9Ru","window":"Modal_window__Gm-xJ","close":"Modal_close__hfgut","active":"Modal_active__ehYRO"};